import api from "../api/axiosInstance";

/**
 * Intercepts a direct delete action and registers it with the Authorization Gate
 * @param {string} table - The exact target SQL database table (e.g., 'projects', 'material_purchases')
 * @param {number|string} id - The primary key ID of the row being targeted
 * @param {string} summary - A detailed, clear layout string showing the owner what is being deleted
 * @param {function} onQueued - Optional callback function to refresh data locally on success
 */
export const triggerSafeDelete = async (table, id, summary, onQueued) => {
    const confirmMessage = `Are you sure you want to request the deletion of:\n"${summary}"?\n\nThis will send an approval request to the Owner/Admin.`;

    if (!window.confirm(confirmMessage)) return;

    try {
        const res = await api.post("request_deletion.php", {
            target_table: table,
            target_id: parseInt(id),
            meta_summary: summary.toUpperCase().trim()
        });

        if (res.data.status === "success") {
            alert(res.data.message);
            if (typeof onQueued === "function") onQueued();
        }
    } catch (err) {
        const errorMsg = err.response?.data?.message || "Critical connection breakdown while pushing request.";
        alert(errorMsg);
    }
};